import { render, staticRenderFns } from "./ReportsView.vue?vue&type=template&id=36bc34c9"
import script from "./ReportsView.vue?vue&type=script&lang=js"
export * from "./ReportsView.vue?vue&type=script&lang=js"
import style0 from "./ReportsView.vue?vue&type=style&index=0&id=36bc34c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports